<template>
  <div 
    ref="containerRef"
    class="relative"
    @mousedown="handleMouseDown"
    @mousemove="handleMouseMove"
    @mouseup="handleMouseUp"
    @mouseleave="handleMouseUp"
  >
    <ColorCircle
      ref="circleRef"
      :type="type"
      :size="size"
    />
    
    <!-- Pips overlay slot -->
    <slot />
    
    <!-- Selection rectangle slot -->
    <slot name="selection-rectangle" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import ColorCircle from './ColorCircle.vue'

interface Props {
  type: 'hue' | 'white'
  size: number
}

defineProps<Props>()

const emit = defineEmits<{
  mouseDown: [event: MouseEvent]
  mouseMove: [event: MouseEvent]
  mouseUp: [event: MouseEvent]
}>()

const containerRef = ref<HTMLDivElement>()
const circleRef = ref()

const handleMouseDown = (event: MouseEvent) => {
  emit('mouseDown', event)
}

const handleMouseMove = (event: MouseEvent) => {
  emit('mouseMove', event)
}

const handleMouseUp = (event: MouseEvent) => {
  emit('mouseUp', event)
}

defineExpose({
  containerRef,
  circleRef
})
</script>
